import { Container } from "./styles";

const PageItem = ({
    page,
    selected,
    changeCurrentPage
}) => {
    return (
        <Container
            className={
                selected
                ? "selected" : ""}
            onClick={() => changeCurrentPage(page)}>
            <span>{page}</span>
        </Container>
    );
}

export default PageItem;